// import Http from '@/utils/request'
import { useDollarGet } from '~/composables/useDollarFetchRequest';
const commonUrl = '/website/common/'

// 语言
export const listDictData = (dictType: any) => useDollarGet(commonUrl+'listDictData/'+dictType)

// 底部友链
export const listFriendlyLink = (params: any) => useDollarGet(commonUrl+'listFriendlyLink?',params);

/* 经销商提交 */
export const registerSubmit = (params: any) => useDollarPost('/website/intend/tenant',params);

/* 产品 */
// 产品型号导航
export const treeConfigUntilModel = (language: any) => useDollarGet(commonUrl+'treeConfigUntilModel/'+language);
// 产品详情
export const treeConfigUntilParam = (language: any, configId: any) => useDollarGet(commonUrl+'treeConfigUntilParam/'+language+'/'+configId);
// 产品配置提交
export const optionalSheet = (params: any) => useDollarPost('/website/optional/sheet',params);

/* 服务与支持页面*/
// 服务网点
export const getNearbyTenant = (params: any) => useDollarGet(commonUrl+'getNearbyTenant?',params);
// 用户使用手册

// 服务公告
export const getBulletin = (language: any) => useDollarGet(commonUrl+'getBulletin/'+language);

/* 行业案列页面*/
// 行业车辆案例
export const pageListIndustryCase = (params: any) => useDollarGet(commonUrl+'pageListIndustryCase?',params);

/* 新闻中心 */
// 列表
export const pageListNews = (params:any) => useDollarGet(commonUrl+'pageListNews?',params);
// 详情
export const newsDetail = (newsId: any) => useDollarGet('/website/news/'+newsId);

/* 企业动态 */
// 列表
export const pageListDynamic = (params: any) => useDollarGet(commonUrl+'pageListDynamic?',params);
// 详情
export const dynamicDetail = (dynamicId: any) => useDollarGet('/website/dynamic/'+dynamicId);


/*使用1
  listDictData('').then((res: any) => {
    data.value = res._rawValue.data
    }).catch((err: any)=>{
  }) 
*/
/*2
  const getList = async() => { // 获取数据
    try {
      const response = await getNearbyTenant(params);
      if(response.data.length){
        list.value = response.data
      }else{
        description.value='暂无数据'
      }
    } catch (error) {
    }
  }
*/